/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React, { type ComponentProps } from 'react';
import wordCount from 'utils/word-count';
import './Statement.scss';

interface StatementProps {
  className?: string;
  children?: string;
  limit?: number;
}

/**
 * This is the Statement component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function Statement({
  className = '',
  children = '',
  limit = 20,
}: StatementProps) {
  let decoration: ComponentProps<'blockquote'> = {};

  if (wordCount(children) < limit) {
    decoration = { 'stagger-text': 'true' };
  } else {
    decoration = { appear: 'true' };
  }

  return (
    <blockquote
      className={`excerpt statement ${className}`.trim()}
      {...decoration}
    >
      <p dangerouslySetInnerHTML={{ __html: children }} />
    </blockquote>
  );
}

export default Statement;
